export const TASK_ADD_REQUEST = "TASK_ADD_REQUEST";
export const TASK_ADD_SUCCESS = "TASK_ADD_SUCCESS";
export const TASK_ADD_FAIL = "TASK_ADD_FAIL";
export const TASK_ADD_REST = "TASK_ADD_REST";

export const TASK_DETAILS_REQUEST = "TASK_DETAILS_REQUEST";
export const TASK_DETAILS_SUCCESS = "TASK_DETAILS_SUCCESS";
export const TASK_DETAILS_FAIL = "TASK_DETAILS_FAIL";

export const TASK_LIST_REQUEST = "TASK_LIST_REQUEST";
export const TASK_LIST_SUCCESS = "TASK_LIST_SUCCESS";
export const TASK_LIST_FAIL = "TASK_LIST_FAIL";

export const TASK_DELETE_REQUEST = "TASK_DELETE_REQUEST";
export const TASK_DELETE_SUCCESS = "TASK_DELETE_SUCCESS";
export const TASK_DELETE_FAIL = "TASK_DELETE_FAIL";

export const TASK_CHECKED_UPDATE_REQUEST = "TASK_CHECKED_UPDATE_REQUEST";
export const TASK_CHECKED_UPDATE_SUCCESS = "TASK_CHECKED_UPDATE_SUCCESS";
export const TASK_CHECKED_UPDATE_FAIL = "TASK_CHECKED_UPDATE_FAIL";
export const TASK_CHECKED_UPDATE_RESET = "TASK_CHECKED_UPDATE_RESET";

export const TASK_PASSED_UPDATE_REQUEST = "TASK_PASSED_UPDATE_REQUEST";
export const TASK_PASSED_UPDATE_SUCCESS = "TASK_PASSED_UPDATE_SUCCESS";
export const TASK_PASSED_UPDATE_FAIL = "TASK_PASSED_UPDATE_FAIL";
export const TASK_PASSED_UPDATE_RESET = "TASK_PASSED_UPDATE_RESET";

export const TASK_NO_PASSED_UPDATE_REQUEST = "TASK_NO_PASSED_UPDATE_REQUEST";
export const TASK_NO_PASSED_UPDATE_SUCCESS = "TASK_NO_PASSED_UPDATE_SUCCESS";
export const TASK_NO_PASSED_UPDATE_FAIL = "TASK_NO_PASSED_UPDATE_FAIL";
export const TASK_NO_PASSED_UPDATE_RESET = "TASK_NO_PASSED_UPDATE_RESET";


export const TASK_MY_LIST_REQUEST = "TASK_MY_LIST_REQUEST";
export const TASK_MY_LIST_SUCCSESS = "TASK_MY_LIST_SUCCSESS";
export const TASK_MY_LIST_FAIL = "TASK_MY_LIST_FAIL";


export const DOWNLOAD_ASSIGNMENT_REQUEST = "DOWNLOAD_ASSIGNMENT_REQUEST";
export const DOWNLOAD_ASSIGNMENT_SUCCSESS = "DOWNLOAD_ASSIGNMENT_SUCCSESS";
export const DOWNLOAD_ASSIGNMENT_FAIL = "DOWNLOAD_ASSIGNMENT_FAIL";



